import React from "react";
import { Card, CardContent } from "./ui/card";
import { 
  Truck, 
  Shield, 
  Clock, 
  MapPin,
  Star,
  Users
} from "lucide-react";

const About = () => {
  const features = [
    {
      icon: Truck,
      title: "Import-Export",
      description: "Expertise internationale dans l'import-export de produits diversifiés"
    },
    {
      icon: Shield,
      title: "Fiabilité",
      description: "Partenaire de confiance avec des produits de qualité contrôlée"
    },
    {
      icon: Clock,
      title: "Réactivité",
      description: "Service client réactif et suivi personnalisé de vos commandes"
    },
    {
      icon: MapPin,
      title: "Local",
      description: "Entreprise rennaise au service des particuliers et professionnels"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
              Qui sommes-nous ?
            </h2>
            <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
              SHADOWTACT SARL est une société spécialisée dans l'import-export et la vente 
              en ligne de produits électroniques, ménagers, de première nécessité, chaussures, 
              vêtements et autres produits non réglementés.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {features.map((feature, index) => (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300 group">
                <CardContent className="p-6 text-center">
                  <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-emerald-200 transition-colors">
                    <feature.icon className="w-8 h-8 text-emerald-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Company Info */}
          <div className="bg-gradient-to-r from-slate-50 to-gray-50 rounded-2xl p-8 lg:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  Notre engagement
                </h3>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  Basée au cœur de Rennes, SHADOWTACT SARL s'engage à offrir 
                  des produits de qualité à des prix compétitifs. Notre expertise 
                  en commerce international nous permet de proposer une gamme 
                  variée répondant aux besoins des particuliers comme des professionnels.
                </p>
                <div className="space-y-3">
                  <div className="flex items-center text-slate-600">
                    <Star className="w-5 h-5 text-emerald-600 mr-3" />
                    Produits de qualité contrôlée
                  </div>
                  <div className="flex items-center text-slate-600">
                    <Users className="w-5 h-5 text-emerald-600 mr-3" />
                    Service client personnalisé
                  </div>
                  <div className="flex items-center text-slate-600">
                    <MapPin className="w-5 h-5 text-emerald-600 mr-3" />
                    Société rennaise de proximité
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <h4 className="text-lg font-semibold text-slate-900 mb-4">
                  Coordonnées
                </h4>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm font-medium text-slate-900">Adresse</p>
                    <p className="text-slate-600">
                      5, Allée de la Grande Treille<br />
                      35200 Rennes
                    </p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-slate-900">Téléphone</p>
                    <p className="text-emerald-600 font-medium">01 85 09 91 73</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;